/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createEventTracking } from 'services/api/tracking';
import { FaUserAlt } from 'react-icons/fa';
import { AiOutlineQuestion } from 'react-icons/ai';
import { IoArrowRedo } from 'react-icons/io5';
import Tooltip from '@material-ui/core/Tooltip';
import { ArrowBack } from '@material-ui/icons';
import { COLOR } from 'assets/styles/colors';
import LoitLogo from 'assets/icons/loit-logo-dash.svg';
import helpIcon from 'assets/icons/help-home.svg';
import visibleIcon from 'assets/icons/visible.svg';
import invisibleIcon from 'assets/icons/invisible.svg';
import { formatCurrency } from 'services/helpers/string';
import {
  BoxHeader, ContainerOptions, BoxUser, BoxOptions,
} from './styles';

// Header da Home
const Header = ({
  currentUser, stepUser, recoverPhone, setRecoverPhone, open, setOpen, setOpenHelper, shareModal, clearData,
}) => {
  const [visible, setVisible] = useState(false);
  const formatName = (name) => (name.indexOf(' ') === -1 ? name : name.substring(0, name.indexOf(' ', 0)));

  const handleShare = async () => {
    if (navigator.share) {
      await navigator.share({
        title: 'LOIT FGTS',
        url: window.location.href,
      });
      await createEventTracking('200 - compartilhamento');
    } else {
      shareModal(true);
    }
  };

  const IconLogin = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.59513 8.36786V1.39464C7.59513 0.625108 8.22482 0 9 0C9.77518 0 10.4049 0.625108 10.4049 1.39464V8.36786C10.4049 9.13739 9.77518 9.7625 9 9.7625C8.22482 9.7625 7.59513 9.13739 7.59513 8.36786ZM14.5688 2.04493C14.1137 1.6872 13.4496 1.76571 13.0893 2.21824C12.7289 2.67152 12.8073 3.32922 13.2639 3.68769C14.9351 4.99642 15.8931 6.95618 15.8931 9.06555C15.8931 12.8384 12.8005 15.9084 9.00075 15.9084C5.2002 15.9084 2.10768 12.8384 2.10768 9.06555C2.10768 6.95692 3.06491 4.9979 4.73464 3.68991C5.19125 3.33218 5.26958 2.67448 4.90923 2.22047C4.54887 1.76719 3.88709 1.69016 3.429 2.04715C1.24969 3.75435 0 6.31255 0 9.06555C0 13.9923 4.0378 18 9 18C13.9622 18 18 13.9916 18 9.06555C18 6.31107 16.7488 3.75287 14.5688 2.04493Z" fill={open ? COLOR.GREY_3 : COLOR.GREEN_1} />
    </svg>
  );

  return (
    <BoxHeader>
      <ContainerOptions align={localStorage.getItem('calculated_value') || recoverPhone} visible={visible}>
        <Tooltip title="Voltar" arrow>
          <ArrowBack aria-label="Voltar" onClick={clearData} style={{ color: COLOR.WHITE_1, display: !recoverPhone && 'none', cursor: 'pointer' }} />
        </Tooltip>
        {localStorage.getItem('calculated_value') && !recoverPhone && (
          <div>
            <p>
              Valor calculado:
            </p>
            <p onClick={() => setVisible(!visible)}>
              <label className="calculated_value">
                {formatCurrency(parseFloat(localStorage.getItem('calculated_value')))}
              </label>
              <img
                src={visible ? visibleIcon : invisibleIcon}
                alt="calculated value"
              />
            </p>
          </div>
        )}
        <img
          src={LoitLogo}
          alt="logo loit fgts"
        />
        <Tooltip title="Segurança" arrow>
          <BoxUser onClick={() => !recoverPhone && setRecoverPhone(stepUser >= 1 ? !recoverPhone : false)} recoverPhone={recoverPhone}>
            <FaUserAlt style={{ width: '24px', height: '18px', color: recoverPhone ? COLOR.GREY_3 : COLOR.GREEN_1 }} />
            <label>
              {currentUser.displayName ? `Olá, ${formatName(currentUser.displayName)}` : 'Olá'}
            </label>
          </BoxUser>
        </Tooltip>
        <Tooltip title="Sair" arrow>
          <BoxOptions aria-label="Sair" onClick={() => setOpen(true)} recoverPhone={recoverPhone}>
            <IconLogin />
          </BoxOptions>
        </Tooltip>
        <Tooltip title="Compartilhar" arrow>
          <BoxOptions aria-label="Compartilhar" style={{ right: '64px' }} onClick={handleShare} recoverPhone={recoverPhone}>
            <IoArrowRedo style={{ width: '24px', height: '24px', color: COLOR.GREEN_1 }} />
          </BoxOptions>
        </Tooltip>
        <Tooltip title="Ajuda" arrow>
          <BoxOptions
            aria-label="Ajuda"
            onClick={() => {
              window.Intercom('trackEvent', 'LOIT FGTS ajuda');
              setOpenHelper(true);
            }}
            style={{ right: '110px' }}
            recoverPhone={recoverPhone}
          >
            <img
              src={helpIcon}
              alt="icon help"
              style={{
                width: '12px',
                height: '18px',
                margin: '0 auto',
              }}
            />
          </BoxOptions>
        </Tooltip>
      </ContainerOptions>
    </BoxHeader>
  );
};

Header.propTypes = {
  currentUser: PropTypes.object.isRequired,
  stepUser: PropTypes.number.isRequired,
  recoverPhone: PropTypes.bool.isRequired,
  setRecoverPhone: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setOpenHelper: PropTypes.func.isRequired,
  shareModal: PropTypes.func.isRequired,
  clearData: PropTypes.func.isRequired,
};

export default Header;
